var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowRight = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.586 2.66675H10.4127C5.55935 2.66675 2.66602 5.56008 2.66602 10.4134V21.5734C2.66602 26.4401 5.55935 29.3334 10.4127 29.3334H21.5727C26.426 29.3334 29.3193 26.4401 29.3193 21.5868V10.4134C29.3327 5.56008 26.4394 2.66675 21.586 2.66675ZM24.706 16.7067L18.986 22.4267C18.786 22.6267 18.5327 22.7201 18.2793 22.7201C18.026 22.7201 17.7727 22.6267 17.5727 22.4267C17.186 22.0401 17.186 21.4001 17.5727 21.0134L21.586 17.0001H7.99935C7.45268 17.0001 6.99935 16.5467 6.99935 16.0001C6.99935 15.4534 7.45268 15.0001 7.99935 15.0001H21.586L17.5727 10.9867C17.186 10.6001 17.186 9.96008 17.5727 9.57341C17.9593 9.18675 18.5993 9.18675 18.986 9.57341L24.706 15.2934C24.8927 15.4801 24.9993 15.7334 24.9993 16.0001C24.9993 16.2667 24.8927 16.5201 24.706 16.7067Z",
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-right.20d1f414.svg";
export { ForwardRef as ReactComponent };